import React from 'react';
import { useAppContext } from '../context/AppContext';

function Filters() {
    const { filters, setFilters, applyFilters, resetFilters } = useAppContext();

    const handleChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value }));
    };

    const handleApply = () => {
        applyFilters(filters);
    };

    return (
        <div className="filters">
            <div className="filter-row filter-search-row">
                <div className="filter-group filter-merchant">
                    <label htmlFor="filter-merchant">Merchant</label>
                    <input
                        id="filter-merchant"
                        type="search"
                        placeholder="Search name…"
                        value={filters.merchantQuery || ''}
                        onChange={(e) => handleChange('merchantQuery', e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleApply(); }}
                    />
                </div>
            </div>
            <div className="filter-row">
                <div className="filter-group">
                    <label htmlFor="filter-source">Source</label>
                    <select
                        id="filter-source"
                        value={filters.source}
                        onChange={(e) => handleChange('source', e.target.value)}
                    >
                        <option value="all">All</option>
                        <option value="phonepe">PhonePe</option>
                        <option value="gpay">GPay</option>
                        <option value="paytm">Paytm</option>
                    </select>
                </div>
                <div className="filter-group">
                    <label htmlFor="filter-type">Type</label>
                    <select
                        id="filter-type"
                        value={filters.type}
                        onChange={(e) => handleChange('type', e.target.value)}
                    >
                        <option value="all">All</option>
                        <option value="DEBIT">Debit</option>
                        <option value="CREDIT">Credit</option>
                    </select>
                </div>
                <div className="filter-group">
                    <label htmlFor="filter-from">From</label>
                    <input
                        id="filter-from"
                        type="date"
                        value={filters.fromDate}
                        onChange={(e) => handleChange('fromDate', e.target.value)}
                    />
                </div>
                <div className="filter-group">
                    <label htmlFor="filter-to">To</label>
                    <input
                        id="filter-to"
                        type="date"
                        value={filters.toDate}
                        onChange={(e) => handleChange('toDate', e.target.value)}
                    />
                </div>
                <div className="filter-actions">
                    <button type="button" className="filter-btn" onClick={handleApply}>Apply</button>
                    <button type="button" className="filter-btn secondary" onClick={resetFilters}>Reset</button>
                </div>
            </div>
        </div>
    );
}

export default Filters;
